import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../utilities/authConfig";
import { Col, Container, Image, Row } from "react-bootstrap";
import StbButton from "../../atoms/button/StbButton";
import "./signinPage.css";
import { BrowserAuthError } from "@azure/msal-browser";

const SignInPage: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      await instance.loginPopup(loginRequest);
    } catch (error) {

      if (error instanceof BrowserAuthError && error.errorCode.includes("user_cancelled")) {
        console.log("user cancelled the login flow.");
        return;
      } else if (error instanceof BrowserAuthError && error.errorCode.includes("interaction_in_progress")) {
        console.log("Login window already open");
        alert("Logga in fönster är redan öppet");
      } else {
        console.error("An error occured during login:", error);
        alert("An error occurred during login. Please try again later.");
      }
    }
  };

  const heroPath: string = "./bg.jpg";
  const logoPath: string = `${process.env.PUBLIC_URL}/logo192.png`;

  return (
    <Container
      className="set-bg signin-container d-flex flex-column justify-content-center align-items-center min-vh-100 min-vw-100"
      style={{ backgroundImage: `url(${heroPath})`, backgroundSize: "cover" }}
    >
      <Row className="signin-row g-0 d-flex justify-content-center align-items-start">
        <p className="hero-text text-center">STB-Portalen</p>
      </Row>
      <Row className="signin-row g-0 d-flex justify-content-center align-items-start">
        <Image className="brand-image" src={logoPath} alt="STB logotyp" />
      </Row>
      <Row className="signin-row g-0 d-flex justify-content-center align-items-center">
        <Col className="d-flex justify-content-center align-items-center">
          <StbButton className="shadow" variant="primary" size="lg" onClick={handleLogin}>
            Logga in
          </StbButton>
        </Col>
      </Row>
    </Container>
  );
};

export default SignInPage;